// engine
import { ArContainer, ArSpine } from "@aceroll/core";

const ANIMATION = {
	SHOW_0: "appear",
	SHOW_1: "appear_1",

	IDLE_0: "idle",
	IDLE_1: "idle_1",
	IDLE_2: "idle_2",

	HIDE_0: "out",
	HIDE_1: "out_1",
}

const SCENARIO_IDLE = [
	ANIMATION.IDLE_0,
	ANIMATION.IDLE_0,
	ANIMATION.IDLE_2,
];

export class HealthPoint extends ArContainer {
	#spine = null;
	#active = false;

	scenarioIndex = 0;
	scenario = null;
	scenarioLoop = false;

	constructor() {
		super('health-point');

		this.#spine = this.addChild(new ArSpine('spine-health-point'));
		this.#spine.scale.set(1.15);
		// this.#spine.static(this._currentSkin, ANIMATIONS.HIDE);
		this.visible = false;

		this.onScenarioComplete = this.onScenarioComplete.bind(this);



		// this.playScenario(SCENARIO_IDLE, true);
	}

	async show() {
		this.visible = true;
	}

	async hide() {
		await this.#spine.setImmediately(this.ANIMATION.HIDE);


		this.visible = false;
	}

	play(animation) {
		this.stop();
		// this.#spine.start();
		this.scenario = null;
		return this.#spine.setImmediately(animation);
	}

	playScenario(scenario, loop = false) {
		this.stop();

		if (this.scenario !== scenario) {
			this.#spine.stop();
			this.scenario = scenario;
			this.scenarioIndex = 0;
			this.scenarioLoop = loop;
		} else {
			this.scenarioIndex = (this.scenario.length - 1) % this.scenarioIndex;
		}
		this.#spine.addEvent('complete', this.onScenarioComplete);

		return this.#spine.addImmediately(this.scenario[this.scenarioIndex]);


	}

	stop() {
		this.#spine.stop();
		this.#spine.removeEvent('complete', this.onScenarioComplete);
	}

	// events
	onScenarioComplete() {
		if (!this.scenario) { return false; }

		this.scenarioIndex++;

		if (this.scenarioIndex < this.scenario.length) {
			return this.#spine.addImmediately(this.scenario[this.scenarioIndex]);
		}

		if (this.scenarioLoop) {
			this.scenarioIndex = 0;
			return this.#spine.addImmediately(this.scenario[this.scenarioIndex]);
		}

		// exit from scenario
		// console.log('STOP SCENARIO');
		this.stop();
	}
	async activate() {
		if (this.#active) { return; }

		this.#active = true;
		this.visible = true;
		await this.play(ANIMATION.SHOW_1);
		return this.playScenario(SCENARIO_IDLE, true);
	}
	async deactivate() {
		if (!this.#active) { return; }

		this.#active = false;
		return this.play(ANIMATION.HIDE_0);
		// this.visible = false;
	}
}
